import { X, ShoppingBag, Trash2, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import './MiniCart.css';

export default function MiniCart({ isOpen, onClose, cart, updateQty, removeItem }) {
  const subtotal = cart.reduce((sum, item) => sum + item.price * (item.qty || 1), 0);

  return (
    <>
      {/* Overlay */}
      <div className={`mini-cart-overlay ${isOpen ? 'open' : ''}`} onClick={onClose} />
      
      {/* Drawer */}
      <div className={`mini-cart-drawer ${isOpen ? 'open' : ''}`}>
        <div className="mini-cart-header">
          <div className="cart-title-wrap">
            <ShoppingBag size={20} />
            <h2>Your Cart ({cart.length})</h2>
          </div>
          <button className="close-btn" onClick={onClose} aria-label="Close cart">
            <X size={24} />
          </button>
        </div>

        <div className="mini-cart-items">
          {cart.length === 0 ? (
            <div className="empty-cart">
              <ShoppingBag size={48} className="empty-icon" />
              <p>Your cart is empty</p>
              <Link to="/shop" className="btn-primary" onClick={onClose}>Shop Now</Link>
            </div>
          ) : (
            cart.map(item => (
              <div key={item.id} className="mini-item">
                <div className="mini-item-img">
                  <img src={item.image} alt={item.name} />
                </div>
                <div className="mini-item-info">
                  <p className="mini-item-name">{item.name}</p>
                  <p className="mini-item-price">₹{item.price}</p>
                  <div className="mini-item-actions">
                    <div className="mini-qty">
                      <button onClick={() => updateQty(item.id, -1)}>-</button>
                      <span>{item.qty || 1}</span>
                      <button onClick={() => updateQty(item.id, 1)}>+</button>
                    </div>
                    <button className="mini-remove" onClick={() => removeItem(item.id)}>
                      <Trash2 size={14} />
                    </button>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>

        {cart.length > 0 && (
          <div className="mini-cart-footer">
            <div className="mini-total">
              <span>Subtotal</span>
              <span>₹{subtotal}</span>
            </div>
            <p className="mini-shipping-note">
              {subtotal < 599 ? `Add ₹${599 - subtotal} for FREE shipping` : '✓ FREE Shipping unlocked!'}
            </p>
            <div className="mini-btns">
              <Link to="/cart" className="btn-outline" onClick={onClose}>View Cart</Link>
              <Link to="/checkout" className="btn-primary" onClick={onClose}>
                Checkout <ArrowRight size={16} />
              </Link>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
